import axios from 'axios'

export const getList = params =>{return axios.get('/api/cms/notice/search',{params:params})};

export const postModify = params =>{return axios.post('/api/cms/notice/modify',params)};



// WEBPACK FOOTER //
// ./src/api/api.js